/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ContractDepartmentDepartmentDto,
  UpdateContractDepartmentDto
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetOrganigramUrl = () => {


  

  return `/api/ContractDepartment/GetOrganigram`
}

export const getOrganigram = async ( options?: RequestInit): Promise<ContractDepartmentDepartmentDto[]> => {
  
  return customInstance<ContractDepartmentDepartmentDto[]>(getGetOrganigramUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetOrganigramQueryKey = () => {
    return [
    `/api/ContractDepartment/GetOrganigram`
    ] as const;
    }

    
export const getGetOrganigramQueryOptions = <TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganigramQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganigram>>> = ({ signal }) => getOrganigram({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOrganigramQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganigram>>>
export type GetOrganigramQueryError = ErrorType<unknown>


export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganigram>>,
          TError,
          Awaited<ReturnType<typeof getOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganigram>>,
          TError,
          Awaited<ReturnType<typeof getOrganigram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOrganigram<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOrganigramQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrganigramSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganigramQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganigram>>> = ({ signal }) => getOrganigram({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOrganigramSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganigram>>>
export type GetOrganigramSuspenseQueryError = ErrorType<unknown>


export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetOrganigramSuspense<TData = Awaited<ReturnType<typeof getOrganigram>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganigram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOrganigramSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getUpdateContractDepartmentUrl = () => {


  

  return `/api/ContractDepartment/UpdateContractDepartment`
}

export const updateContractDepartment = async (updateContractDepartmentDto: UpdateContractDepartmentDto, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateContractDepartmentUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContractDepartmentDto,)
  }
);}




export const getUpdateContractDepartmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext> => {

const mutationKey = ['updateContractDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractDepartment>>, {data: BodyType<UpdateContractDepartmentDto>}> = (props) => {
          const {data} = props ?? {};

          return  updateContractDepartment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractDepartment>>>
    export type UpdateContractDepartmentMutationBody = BodyType<UpdateContractDepartmentDto>
    export type UpdateContractDepartmentMutationError = ErrorType<unknown>

    export const useUpdateContractDepartment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractDepartment>>, TError,{data: BodyType<UpdateContractDepartmentDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContractDepartment>>,
        TError,
        {data: BodyType<UpdateContractDepartmentDto>},
        TContext
      > => {

      const mutationOptions = getUpdateContractDepartmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    